export default "__VITE_ASSET__DEr0dDnV__"